module.exports = __webpack_public_path__ + "assets/img/driver-btn-3af3d570.png";